/**
 * VideoLoadingOverlay — the capsule video "not ready to play" state: the
 * video's first-frame thumbnail, blurred, fills the surface and the white
 * capsule loading animation spins in the center. Shown only while the ACTIVE
 * capsule's video is still loading (cold start or a mid-play buffer stall)
 * and hidden the moment the media can play.
 *
 * Purely presentational and pointer-transparent, so the capsule front (data
 * and buttons) stays visible and interactive underneath it.
 */
import {StyleSheet, View} from 'react-native'
import {Image} from 'expo-image'
import LottieView from 'lottie-react-native'

import {atoms as a} from '#/alf'
import loadingVideoAnimation from '../../../../assets/capsule/animations/loadingVideo.json'

export function VideoLoadingOverlay({thumbnail}: {thumbnail?: string}) {
  return (
    <View
      pointerEvents="none"
      style={[
        StyleSheet.absoluteFill,
        a.align_center,
        a.justify_center,
        // Above the transport layer (z10), below the capsule front (z20).
        {zIndex: 15},
      ]}>
      {/* Blurred first-frame thumbnail as the loading background. Oversized
          beyond the screen (and blurred hard) so the wash covers the whole
          surface edge-to-edge — no centered look, no recognizable details,
          no dark fringe where the blur hits the image bounds. */}
      {thumbnail ? (
        <Image
          source={{uri: thumbnail}}
          style={{
            position: 'absolute',
            top: -56,
            left: -56,
            right: -56,
            bottom: -56,
          }}
          contentFit="cover"
          blurRadius={48}
          accessibilityIgnoresInvertColors
          transition={150}
          priority="high"
        />
      ) : null}
      {/* A faint dark halo keeps the white animation readable on any (even a
          bright) blurred thumbnail. */}
      <View
        style={{
          width: 96,
          height: 96,
          borderRadius: 48,
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <LottieView
          source={loadingVideoAnimation}
          autoPlay
          loop
          style={{width: 72, height: 72}}
        />
      </View>
    </View>
  )
}
